





























import Component from 'vue-class-component';
import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import {DisguiseRoute} from '@/routetype';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';

export interface BreadCrumbConfig {
  text: string;
  routes: DisguiseRoute[];
}

@Component
export default class BreadcrumbTemplate extends Vue {

  @Prop() children!: DisguiseRoute[]; // comes from navi service

  passthroughAllEventsVueOnMap: VueOnMapType =
      FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
        this.$emit(eventName, eventArgs);
      });

  breadcrumbs: BreadCrumbConfig[] = [];
  // an increase of this number indicates a necessary rerending of the component in the content section
  componentRenderKeyCount: number = 0;

  created() {
    this.breadcrumbs.push({
      text: this.children.length > 0 ? this.children[0].meta?.naviText || '' : '',
      routes: this.children || [],
    });
  }

  addToStack(newEntry: BreadCrumbConfig) {
    this.breadcrumbs.push(newEntry);
    this.componentRenderKeyCount++;
  }

  breadcrumbClicked(config: BreadCrumbConfig) {
    const idx = this.breadcrumbs.indexOf(config);
    this.breadcrumbs.splice(idx + 1);
    this.componentRenderKeyCount++;
  }

}
